import {Dispatch} from 'redux';
import {BESport} from 'API/types';
import {
  SPORTEVENTS_BY_DATE_GET_INVALIDATE,
  SPORTEVENTS_BY_DATE_GET_REQUEST,
  SPORTEVENTS_BY_DATE_GET_RESPONSE,
} from '../../actionTypes';
import {
  SportEventsByDateGetInvalidateAction,
  SportEventsByDateGetRequestAction,
  SportEventsByDateGetResponseAction,
} from '../types';
import {sportEventsByDate} from '../../../API/sportEvents';
import {MatchSimple} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beMatchSimpleToMatchSimple} from '../../../API/utils';
import validateBEMatchSimpleArray from '../../../API/validation';

/**
 * Action creator for the get request of the sport events by date
 * @param date
 */
const getSportEventsByDateGetRequest = (date: string): SportEventsByDateGetRequestAction => ({
  type: SPORTEVENTS_BY_DATE_GET_REQUEST,
  payload: date,
});

/**
 * Action creator for the request response of the sport events by date
 * @param matches
 * @param date
 */
const getSportEventsByDateGetResponse = (
  matches: MatchSimple[],
  date: string
): SportEventsByDateGetResponseAction => ({
  type: SPORTEVENTS_BY_DATE_GET_RESPONSE,
  payload: {matches, date},
});

/**
 * Action creator for the request invalidate of the sport events by date
 * @param error
 */
const getSportEventsByDateGetInvalidate = (error: Error): SportEventsByDateGetInvalidateAction => ({
  type: SPORTEVENTS_BY_DATE_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getSportEventsByDate = (date: string) => (dispatch: Dispatch): Promise<any> => {
  dispatch(getSportEventsByDateGetRequest(date));

  return (
    sportEventsByDate(date)
      // .then(validateBEMatchSimpleArray)
      // TODO: remove filters
      .then(data =>
        data.filter(match =>
          [BESport.SOCCER, BESport.BASKETBALL, BESport.TENNIS, BESport.HANDBALL, BESport.VOLLEYBALL].includes(match.sportType)
        )
      )
      .then(data => data.map(beMatchSimpleToMatchSimple))
      .then((matches: MatchSimple[]) => dispatch(getSportEventsByDateGetResponse(matches, date)))
      .catch((error: Error) => dispatch(getSportEventsByDateGetInvalidate(error)))
  );
};

export default getSportEventsByDate;
